import React, {Component} from 'react';
import {Card, CardHeader, Col, FormGroup, Label, Row, TabContent, TabPane} from "reactstrap";
import Alert from 'react-s-alert';
import DefaultModal from "../DefaultModal";
import NumberFormat from 'react-number-format';
import Dropzone from 'react-dropzone'
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";

class CezaeviModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnDisabled: false,
            activeTab: 'uploadPdfTab',
            cezaeviData: {
                type: "cezaeviEczanem",
                receiptCount: 0,
                totalPrice: 0,
                publicAllowance: 0,
                publicPriceTotal: 0,
                medicineDifferenceAmount: 0,
                allowance: 0,
                share10And20Amount: 0,
                kdv8Amount: 0,
                kdv8TaxableAmount: 0,
                payableAmount: 0,
                remuneration: 0,
                remunerationKdv18: 0,
                totalPayablePrice: 0
            }
        };
        this.onChange = this.onChange.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    onChange(e) {
        let {name, value} = e;
        let cezaeviData = this.state.cezaeviData;
        cezaeviData[name] = value;
        this.setState({cezaeviData});
    }

    onDrop(acceptedFiles, rejectedFiles) {
        if (rejectedFiles && rejectedFiles.length) {
            Alert.error("PDF dosyası yüklemelisiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                html: true,
                timeout: 1000
            });
            return;
        }

        if (!acceptedFiles || !acceptedFiles[0])
            return;

        let file = acceptedFiles[0];
        let self = this;

        let formData = new FormData();
        formData.append("file", file);
        let params = {
            url: "/invoiceTmp/uploadCezaeviPdf",
            method: "post",
            data: formData
        };

        let cezaeviData = {
            type: "cezaeviEczanem",
            receiptCount: 0,
            totalPrice: 0,
            publicAllowance: 0,
            publicPriceTotal: 0,
            medicineDifferenceAmount: 0,
            allowance: 0,
            share10And20Amount: 0,
            kdv8Amount: 0,
            kdv8TaxableAmount: 0,
            payableAmount: 0,
            remuneration: 0,
            remunerationKdv18: 0,
            totalPayablePrice: 0
        };

        self.setState({uploading: true, cezaeviData});
        request(params)
            .then(function (response) {
                let data = response.data;
                cezaeviData = {
                    type: data.type,
                    recipeCount: data.recipeCount,
                    totalPrice: data.totalPrice,
                    publicAllowance: data.publicAllowance,
                    publicPriceTotal: data.publicPriceTotal,
                    medicineDifferenceAmount: data.medicineDifferenceAmount,
                    allowance: data.allowance,
                    share10And20Amount: data.share10And20Amount,
                    kdv8Amount: data.kdv8Amount,
                    kdv8TaxableAmount: data.kdv8TaxableAmount,
                    payableAmount: data.payableAmount,
                    remuneration: data.remuneration,
                    remunerationKdv18: data.remunerationKdv18,
                    totalPayablePrice: data.totalPayablePrice
                };
                self.setState({cezaeviData, activeTab: 'enterValueTab'});
            }).catch(function (error) {
            self.setState({uploading: false});
            showAxiosError(error);
        });
    }

    render() {
        let cezaeviData = this.state.cezaeviData;
        return (
            <DefaultModal disabled={this.state.btnDisabled}
                          size="lg"
                          isOpen={this.props.cezaeviModal}
                          title="Cezaevi Fatura Eczane Döküm Aktarımı"
                          confirmBtnText="Uygula"
                          cancelBtnText="Kapat"
                          onConfirm={() => this.setState({btnDisabled: false}, () => {
                              this.props.applyCezaevi(this.state.cezaeviData);
                          })}
                          onCancel={(e) => this.setState({btnDisabled: false}, () => {
                              this.props.toggleModal(false);
                          })}>
                <Card className="">
                    <CardHeader>
                        <div className="nav-tabs-navigation">
                            <div className="nav-tabs-wrapper">
                                <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'uploadPdfTab' ? 'active' : '')}
                                           onClick={() => {
                                               this.setState({activeTab: 'uploadPdfTab'})
                                           }}
                                           data-toggle="tab">PDF'ten Aktarım</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'enterValueTab' ? 'active' : '')}
                                           onClick={() => {
                                               this.setState({activeTab: 'enterValueTab'})
                                           }}
                                           data-toggle="tab">Manuel Giriş</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </div>
                        </div>
                    </CardHeader>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="uploadPdfTab">
                            <Col sm="12" style={{paddingLeft: 0}}>
                                <Col sm={12}>
                                    <Dropzone
                                        accept=".pdf"
                                        className="FormRenk col-sm-12"
                                        activeClassName="dropzoneActiveClass"
                                        style={{marginTop: '15px'}}
                                        multiple={false}
                                        maxSize={5000000}
                                        onDrop={this.onDrop}>
                                        <div className="dropzoneInnerArea">
                                            Cezaevi Fatura Döküm PDF'ini buraya sürükleyiniz.
                                        </div>
                                    </Dropzone>
                                </Col>
                            </Col>
                        </TabPane>
                        <TabPane tabId="enterValueTab">
                            <Row style={{paddingLeft: 0}}>
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Reçete Sayısı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="recipeCount"
                                                          value={cezaeviData.recipeCount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "recipeCount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Reçete Psf Toplamı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="totalPrice"
                                                          value={cezaeviData.kdv8TaxableAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "totalPrice"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Kamu Kurum İskontosu Toplamı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="publicAllowance"
                                                          value={cezaeviData.publicAllowance}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "publicAllowance"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Kamu Fiyatları Toplamı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="publicPriceTotal"
                                                          value={cezaeviData.publicPriceTotal}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "publicPriceTotal"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>İlaç Fark Toplamı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="medicineDifferenceAmount"
                                                          value={cezaeviData.medicineDifferenceAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "medicineDifferenceAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>İskonto Tutarı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="allowance"
                                                          value={cezaeviData.allowance}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "allowance"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>%10-20 Katılım Payları Toplamı: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="share10And20Amount"
                                                          value={cezaeviData.share10And20Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "share10And20Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV %8: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv8Amount"
                                                          value={cezaeviData.kdv8Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv8Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Ödenecek Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="payableAmount"
                                                          value={cezaeviData.payableAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "payableAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Eczane Hizmet Bedeli: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="remuneration"
                                                          value={cezaeviData.remuneration}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "remuneration"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Eczane Hizmet Bedeli KDV (%18): *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="remunerationKdv18"
                                                          value={cezaeviData.remunerationKdv18}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "remunerationKdv18"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                                {this.state.cezaeviData.type === "cezaeviEczanem" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>Toplam Ödenecek Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="totalPayablePrice"
                                                          value={cezaeviData.totalPayablePrice}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "totalPayablePrice"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                            </Row>
                        </TabPane>
                    </TabContent>
                </Card>
            </DefaultModal>
        )
    }
}

export default CezaeviModal;